module.exports = __webpack_public_path__ + "static/c11-09e0e39e505b751e6b899b6d73e35267.png";